// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rB1h8","content":"styles_content__1l7mr"};